export default "__VITE_ASSET__CZK0kGPZ__"